import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles(() => ({
  table: {
    minWidth: 650,
  },
}));

export default useStyle;
